import axios from 'axios';

// Create a dedicated Axios instance with baseURL configured
const baseURL = process.env.REACT_APP_API_URL || (
  typeof window !== 'undefined' && window.location.port === '3000'
    ? 'http://localhost:5000'
    : ''
);

const api = axios.create({ baseURL });

export default api;
